import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import * as React from 'react';
import * as _ from 'underscore';

import { CommonStyles } from '../../common/react/CommonStyles';
import { DataGridCells } from '../../common/react/components/dataGrid/DataGridCells';
import { IReactTranslateService } from '../../common/react/IReactTranslateService';
import { cssClass, textEllipsis } from '../../style';
import { L10n } from '../../ts/L10n/L10n';
import { INamedItemInfo } from '../../ts/models/resourceInfoParts';

export function itemsCellWithPopover(
  getItemsForRow: (row: DataGrid.Row) => ReadonlyArray<INamedItemInfo>,
  popoverTitleLocKey: string,
  translate: IReactTranslateService,
): React.StatelessComponent<BodyCell.Props> {
  return function ItemsCellWithPopover(props: BodyCell.Props): JSX.Element {
    const items = getItemsForRow(props.row);
    const itemCount = items.length;
    const firstItemName = itemCount > 0 ? items.find(item => item !== undefined).name : '';
    return DataGridCells.PlainTextCellWithCount(
      firstItemName,
      getListPopoverContent(getItemsForRow, popoverTitleLocKey, translate),
      additionalItemsText(itemCount, translate)
    )(props);
  };
}

const cssPrefix = 'ItemsCellPopover';

const popoverRows = cssClass(cssPrefix, 'rows', {
  marginTop: CommonStyles.Sizes.DefaultSpace
});

const popoverRow = cssClass(cssPrefix, 'row', textEllipsis, {
  height: CommonStyles.Sizes.CompactRowHeight,
  lineHeight: CommonStyles.Sizes.CompactRowHeight + 'px',
  cursor: 'default'
});

function getListPopoverContent(
  getItemsForRow: (row: DataGrid.Row) => ReadonlyArray<INamedItemInfo>,
  popoverTitleLocKey: string,
  translate: IReactTranslateService,
): (props: BodyCell.Props) => Promise<JSX.Element> {
  return (props: BodyCell.Props) => {
    const items = getItemsForRow(props.row);
    const titleString = translate(popoverTitleLocKey, {
      COUNT: items.length
    }, L10n.Interpolations.Count);
    return Promise.resolve(
      <div data-tb-test-id="popover-menu-panel">
        <div className="tb-content-item-popover-title">{titleString}</div>
        <div className={popoverRows}>
          {_.map(items, listPopoverRow)}
        </div>
      </div>
    );
  };
}

function listPopoverRow(item: INamedItemInfo): JSX.Element {
  return (
    <div className={popoverRow} key={item.id}>
      <span title={item.name}>{item.name}</span>
    </div>
  );
}

function additionalItemsText(itemCount: number, translate: IReactTranslateService): string {
  if (itemCount === 0 || itemCount === 1) {
    return '';
  }

  return translate('additionalItemsPillText', {
    ADDITIONAL_COUNT_TEXT: L10n.localizedCount(itemCount - 1)
  });
}
